import { useEffect, useState } from "react";
import apiClient from "../api/client";

export const useAdminUsers = () => {
  const [assignTos, setAssignTos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get("/api/adminusers")
      .then((res) => {
        setAssignTos(res.data || []);
      })
      .catch((err) => {
        console.error("Failed to load admin users:", err);
        setAssignTos([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); 

  return { 
    assignTos,  
    loading 
  };
};